'use client';

import { useAtomSet, useAtomValue } from '@effect/atom-react';
import { FilterChips } from '@vs-shop/commerce-ui/filterChips';
import type { ListingScopeKey } from '@vs-shop/engine/capability/productListing/listingScope';
import { Array, Match } from 'effect';
import { ListingChange } from '@vs-shop/engine/capability/productListing/listingSelection';
import { useIntl } from 'react-intl';
import { rcprofiListingJourney } from '../../../effect/listing/listingJourney';
import { listingFacetPresentation } from './listingFacetPresentation';
import ProductsSelectedFilterChip from './ProductsSelectedFilterChip';
import ProductsSelectedFilterClearAll from './ProductsSelectedFilterClearAll';

type Props = { readonly scopeKey: ListingScopeKey };

export const ListingSelectedFilters = ({ scopeKey }: Props) => {
  const intl = useIntl();
  const binding = rcprofiListingJourney.bind(scopeKey);
  const state = useAtomValue(binding.state);
  const current = useAtomValue(binding.current);
  const change = useAtomSet(binding.change, { mode: 'value' });
  const { chips } = listingFacetPresentation({ state, current, intl });
  if (Array.isReadonlyArrayEmpty(chips)) return null;
  return (
    <FilterChips
      data-slot="products-filter-chips"
      aria-label={intl.formatMessage({
        id: 'component.client.products.productsSelectedFilters.label',
        defaultMessage: 'Aktivní filtry',
      })}
      className="mb-4"
    >
      {Array.map(chips, (chip) => (
        <ProductsSelectedFilterChip
          key={chip.id}
          filterType={chip.filterType}
          label={chip.label}
          value={chip.value}
          {...Match.value(chip).pipe(
            Match.tag('Term', ({ spokenValue }) => ({ spokenValue })),
            Match.tag('Range', () => ({})),
            Match.exhaustive
          )}
          onRemove={() => change(chip.remove)}
        />
      ))}
      <ProductsSelectedFilterClearAll
        onClickAction={() => change(ListingChange.cases.ClearAll.make({}))}
      />
    </FilterChips>
  );
};
